import { render, staticRenderFns } from "./secondInstance.vue?vue&type=template&id=302ebfd7&scoped=true&"
import script from "./secondInstance.vue?vue&type=script&lang=tsx&"
export * from "./secondInstance.vue?vue&type=script&lang=tsx&"
import style0 from "./secondInstance.vue?vue&type=style&index=0&id=302ebfd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ebfd7",
  null
  
)

export default component.exports